import type { ComponentProps, FC, MouseEvent } from 'react';

import { Icon } from '@iconify/react';
import { Badge, IconButton, Popover, Typography } from '@mui/material';
import { useState } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  typography: {
    padding: theme.spacing(1),
  },
}));

type Props = {
  copyString: string;
  edge?: ComponentProps<typeof IconButton>['edge'];
  showBadge?: boolean;
  title?: string;
};

export const CopyButton: FC<Props> = ({
  copyString,
  edge,
  showBadge,
  title = 'metadata',
}) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleCopyClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    void navigator.clipboard.writeText(copyString).then(() => {
      setTimeout(() => {
        setAnchorEl(null);
      }, 1500);
    });
  };

  return (
    <>
      <Badge
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        badgeContent={title}
        component="span"
        invisible={!showBadge}
        overlap="circular"
      >
        <IconButton
          data-value={copyString}
          edge={edge}
          onClick={handleCopyClick}
          title={`Copy ${title}: ${copyString}`}
        >
          <Icon icon="mdi:content-copy" />
        </IconButton>
      </Badge>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        open={Boolean(anchorEl)}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      >
        <Typography className={classes.typography}>
          {title}
          {' '}
          copied to clipboard!
        </Typography>
      </Popover>
    </>
  );
};
